import React from 'react'
import './styles.css'
function NetworkSwitch() {
    return (
        <div class="modal fade Ex-modal wrong-chain-modal" id="wrong-chain" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content" style={{ zIndex: "10000000000000" }}>
                    <div class="modal-body text-center pt-4 pb-5">
                        <div class="row jutify-content-center">
                            <div class="col">
                                <div class="wrong-chain-body">
                                    <div class="hide-mb" style={{ display: "flex", justifyContent: "center", alignItems: "center" }} data-bs-dismiss="modal">
                                        &times;
                                    </div>
                                    <div class="c-content">
                                        <div class="warning-img mb-4">

                                            <svg width="80px" aria-hidden="true" focusable="false" data-prefix="fas"
                                                data-icon="exclamation-triangle" role="img" xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 576 512" class="text-yellow-400 mx-1 text text-3xl  md:text-5xl svg-inline--fa 
                                        fa-exclamation-triangle fa-w-18"><path fill="currentColor"
                                                    d="M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z" class=""></path></svg>

                                        </div>
                                        <p class="wrong-chain-msg">
                                            {`Wrong chain please setup ${localStorage.getItem("currentNetwork") == "MUMBAI" ? "POLYGON" : ''} ${localStorage.getItem("currentNetwork") == undefined || localStorage.getItem("currentNetwork") == null ? "POLYGON" : ''} ${localStorage.getItem("currentNetwork") == "EHETERUM" ? "ETHEREUM" : ''} ${localStorage.getItem("currentNetwork") == "BINANCE" ? "BINANCE" : ''} ${process.env.REACT_APP_ENVIRONMENT == "live" ? "Mainnet" : "Testnet"}  on Metamask`}
                                        </p>
                                        <ul class="nav justify-content-center mt-4 align-items-center">
                                            <li class="nav-item px-3">
                                                <a href="#">
                                                    <img width="100" src={`${process.env.REACT_APP_IMAGE_URL}/assets/images/ex-sports-logo.png`} alt="ex-logo" />
                                                </a>
                                            </li>
                                            <li class="nav-item px-3">
                                                <i class="bi bi-check-lg" style={{ fontSize: "35px", color: "green", fontWeight: "bold" }}></i>
                                            </li>
                                            <li class="nav-item">
                                                <a href="#">
                                                    <img width="50" src="assets/images/icons/metamask.png" alt="metamask-logo" />
                                                </a>
                                            </li>
                                            <li class="nav-item px-3">
                                                <i class="bi bi-x-lg" style={{ fontSize: "25px", color: "red", fontWeight: "bold" }}></i>
                                            </li>
                                            <li class="nav-item">
                                                <a href="#">
                                                    {localStorage.getItem("currentNetwork") == "MUMBAI" || localStorage.getItem("currentNetwork") == undefined ? <img width="50" src={`${process.env.REACT_APP_IMAGE_URL}/assets/images/icons/polygon-token.svg`} alt="metamask-logo" /> : null}

                                                    {localStorage.getItem("currentNetwork") == "EHETERUM" ? <img width="50" src={`${process.env.REACT_APP_IMAGE_URL}/assets/images/icons/ethereum.svg`} alt="metamask-logo" /> : null}
                                                    {localStorage.getItem("currentNetwork") == "BINANCE" ? <img width="50" src={`${process.env.REACT_APP_IMAGE_URL}/assets/images/icons/bnb.svg`} alt="metamask-logo" /> : null}
                                                </a>
                                            </li>
                                        </ul>
                                        <a href="" class="button btn btn-accept" data-bs-dismiss="modal">
                                            Accept
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NetworkSwitch
